import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { toast } from 'ngx-sonner';
@Injectable({ providedIn: 'root' })
export class HandleSuccessService {
    /**
     * Constructor
     */

    protected readonly toast = toast;
    constructor() {}

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Handling HTTP error using toastr
     *
     * @param err
     */
    handleSuccess(
        response: HttpResponse<any>,
        requestMethod: string,
        requestUrl: string
    ) {
        let successMsg: string;

        // Check if response body has a message property
        const responseBody = response.body;
        if (
            responseBody &&
            typeof responseBody === 'object' &&
            'message' in responseBody &&
            responseBody.message
        ) {
            successMsg = responseBody.message;
        } else {
            switch (response.status) {
                case 200:
                    successMsg = this.handleMsg(requestMethod, requestUrl);
                    break;
                default:
                    successMsg = 'Successfully Updated';
            }
        }

        this.toast.success(successMsg);
    }

    private handleMsg(requestMethod, requestUrl: string) {
        if (requestMethod == 'DELETE') {
            return 'Successfully Deleted';
        }

        if (requestUrl.toLocaleLowerCase().includes('update')) {
            return 'Successfully Updated';
        }

        if (requestUrl.toLocaleLowerCase().includes('create')) {
            return 'Successfully Created';
        }

        if (requestUrl.toLocaleLowerCase().includes('add')) {
            return 'Successfully Added';
        }

        return 'Success';
    }
}
